import React from 'react';

export default function getFormattedDurationOver24hours(time: string): string {
  const timeArr: string[] = time.split(':');

  const timeArrLenght = timeArr.length;

  if (timeArrLenght < 1 || timeArrLenght > 3) {
    return '';
  }

  const hoursInSec = Number(timeArr[0]) * 3600;
  const minutesInSec = Number(timeArr[1]) * 60;
  const sec = timeArrLenght === 3 ? Number(timeArr[2]) : 0;

  const totalSec = hoursInSec + minutesInSec + sec;

  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec > 0 ? totalSec % 60 : 0;

  /* ${String(
    s,
  ).padStart(2, '0')} */

  let formattedTime = '';

  if (h > 0) {
    formattedTime = `${String(h).padStart(2, '0')}h${String(m).padStart(
      2,
      '0',
    )}min`;
  } else if (h === 0 && m > 0) {
    formattedTime = `${String(m).padStart(2, '0')}min`;
  } else {
    formattedTime = `${String(s).padStart(2, '0')}s`;
  }

  return formattedTime;
}
